export const armouringDocumentsActionTypes = {
  createRequest: 'CREATE_ARMOURING_DOCUMENTS_REQUEST',
  createSuccess: 'CREATE_ARMOURING_DOCUMENTS_SUCCESS',
  createFailure: 'CREATE_ARMOURING_DOCUMENTS_FAILURE'
}
